(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winners-carousel"] && !Shopify.designMode) return;
  try {
    
  // One WinnersCarousel section can hold several groups (a heading + its own scroll track + arrows).
  // We build one Group controller per `.winners__group`. Each controller drives its own track and
  // shows/hides its arrows based on whether that track actually overflows — so a desktop grid (no
  // overflow) or a ≤3-card carousel shows none, while any overflowing track (always on mobile) shows
  // them. A single resize/ResizeObserver re-runs every controller so layout changes re-evaluate.
  class WinnersGroup {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-cards]');
      const nav = root.querySelector('[data-nav]');
      this.prev = nav && nav.querySelector('[data-dir="-1"]');
      this.next = nav && nav.querySelector('[data-dir="1"]');
      this.update = this.update.bind(this);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      if (this.track) {
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
      }
      this.update();
    }

    step() {
      const card = this.track.firstElementChild;
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      // Arrows only make sense when the track overflows its container.
      this.root.classList.toggle('winners__group--scrollable', max > 0);
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    go(dir) {
      const size = this.step();
      if (!size) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const target = Math.max(0, Math.min(max, (Math.round(this.track.scrollLeft / size) + dir) * size));
      this.track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(() => {
        if (Math.abs(this.track.scrollLeft - target) > 4) this.track.scrollLeft = target;
        this.update();
      }, 300);
      setTimeout(() => this.update(), 700);
    }
  }

  class WinnersCarousel extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.winners__group')).map((g) => new WinnersGroup(g));
      this.onResize = () => this.groups.forEach((g) => g.update());
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
  }
  if (!customElements.get('winners-carousel')) {
    customElements.define('winners-carousel', WinnersCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
